import '../styles/PlantCard.css';
import { Wind, Sprout, PlusCircle } from 'lucide-react';

const PlantCard = ({ plant, index, onLearnMore, onAddToGarden }) => {
  return (
    <div
      className="plant-card"
      style={{ animationDelay: `${index * 150}ms` }}
    >
      <div className="card-image-frame">
        <img src={plant.representative_image_url} alt={plant.common_name} className="plant-image" />
        <div className="image-overlay-gradient"></div>
        <span className="category-badge">{plant.category}</span>
      </div>

      <div className="card-body">
        <div className="card-text-content">
          <h3 className="plant-name">{plant.common_name}</h3>
          <p className="plant-scientific">{plant.scientific_name}</p>
        </div>

        <div className="plant-tags">
          <span className="tag">
            <Wind size={12} /> {plant.min_days_to_harvest}-{plant.max_days_to_harvest} Days
          </span>
          <span className={`tag difficulty-${plant.growth_difficulty}`}>
            <Sprout size={12} /> {plant.growth_difficulty}
          </span>
        </div>

        <div className="card-actions">
          <button className="btn-text" onClick={onLearnMore}>
            Read More
          </button>
          <button className="btn-icon-primary" onClick={onAddToGarden} aria-label="Add to garden">
            <PlusCircle size={24} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlantCard;